var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsBottomHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 242 224.23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Tertiary",
    d: "M0 .6h242v160.03L0 139.49z",
    fill: "#f39200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Secondary",
    d: "M0 1.32h242v119.3L0 199.5z",
    fill: "#ffba00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Primary",
    d: "M0 0h242v54.23l-242 170z",
    fill: "#3c6fb6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsBottomHigh);
export default __webpack_public_path__ + "static/media/details_bottom_high.7406e64a909e923db2d71e4c6da07c8a.svg";
export { ForwardRef as ReactComponent };